<template>
    <!-- Booking Confirmed Modal -->
    <div class="modal fade" id="bookingconfirmModal" tabindex="-1" aria-labelledby="bookingconfirmModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header text-center d-inline-block">
                    <img src="@/assets/img/icons/booking-confirmed.svg" alt="Icon">
                </div>
                <div class="modal-body text-center">
                    <h3 class="mb-3">Booking has been Confirmed</h3>
                    <p>Check your email on the booking confirmation</p>
                </div>
                <div class="modal-footer text-center d-inline-block">
                    <router-link to="/user/user-dashboard" class="btn btn-primary"><i class="feather-arrow-left-circle me-1"></i>Back
                        to Dashboard</router-link>
                </div>
            </div>
        </div>
    </div>
    <!-- /Booking Confirmed Modal -->
</template>